import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { ListItemIcon, ListItemText, Menu, MenuItem, Tooltip } from "@mui/material";
import { cloneElement, useId, useState } from "react";
const ActionMenuItem = (props)=>{
    const contentLabel = typeof props.content === 'string' ? props.content : undefined;
    const secondaryLabel = typeof props.secondary === 'string' ? props.secondary : undefined;
    const label = contentLabel && secondaryLabel ? `${contentLabel} (${secondaryLabel})` : contentLabel;
    const onClick = ()=>{
        if (props.disabled) {
            return;
        }
        if (props.onSelect) {
            props.onSelect();
        }
        if (props.onClose) {
            props.onClose();
        }
    };
    /* a disabled MenuItem drops pointer events, which would mute the tooltip */ const item = /*#__PURE__*/ _jsxs(MenuItem, {
        "aria-label": label,
        autoFocus: props.index === 0 && !props.disabled,
        "data-testid": props.content,
        disabled: props.disabled,
        onClick: onClick,
        sx: {
            ...props.destructive && {
                color: 'error.main'
            },
            ...props.disabled && props.tooltip && {
                '&.Mui-disabled': {
                    pointerEvents: 'auto'
                }
            }
        },
        children: [
            props.icon && /*#__PURE__*/ _jsx(ListItemIcon, {
                children: props.icon
            }),
            /*#__PURE__*/ _jsx(ListItemText, {
                secondary: props.secondary,
                children: props.content
            })
        ]
    });
    return props.tooltip ? /*#__PURE__*/ _jsx(Tooltip, {
        title: props.tooltip,
        children: item
    }) : item;
};
export const ActionMenu = (props)=>{
    const menuId = useId();
    const triggerId = useId();
    const [anchorEl, setAnchorEl] = useState(null);
    const isOpen = Boolean(anchorEl);
    const onClick = (event)=>{
        setAnchorEl(event?.target);
        props.onOpen?.();
    };
    const onClose = ()=>{
        setAnchorEl(null);
    };
    const trigger = /*#__PURE__*/ cloneElement(props.trigger, {
        ...props.trigger.props,
        'aria-controls': isOpen ? menuId : undefined,
        'aria-expanded': isOpen ? 'true' : undefined,
        'aria-haspopup': 'true',
        id: triggerId,
        onClick,
        role: 'button'
    });
    const actions = props.actions?.filter((a)=>!!a);
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            trigger,
            /*#__PURE__*/ _jsx(Menu, {
                anchorEl: anchorEl,
                id: menuId,
                MenuListProps: {
                    'aria-labelledby': triggerId
                },
                onClose: onClose,
                open: isOpen,
                children: actions.length ? actions.map((action, index)=>/*#__PURE__*/ _jsx(ActionMenuItem, {
                        content: action.content,
                        destructive: action.destructive,
                        disabled: action.disabled,
                        icon: action.icon,
                        index: index,
                        onClose: onClose,
                        onSelect: action.onSelect,
                        secondary: action.secondary,
                        tooltip: action.tooltip
                    }, index)) : /*#__PURE__*/ _jsx(ActionMenuItem, {
                    content: "No Items",
                    index: 0
                })
            })
        ]
    });
};
ActionMenu.displayName = 'ActionMenu';

//# sourceMappingURL=ActionMenu.js.map